import { wrapMethodsWithLogging } from "../../components/helpers/ErrorHandlingHelpers";
import BaseApiRepository from "./BaseApiRepository";

const BaseRepository = {
    async getAsync(url) {
        return await BaseApiRepository.getAsync(`incident/incident-pilot/${url}`);
    },
    async putAsync(url, obj) {
        return await BaseApiRepository.putAsync(`incident/incident-pilot/${url}`, obj);
    },
    async deleteAsync(url) {
        return await BaseApiRepository.deleteAsync(`incident/incident-pilot/${url}`);
    },
}

export const IncidentPilotApiRepository = {

    async getByIdAsync(pilotId) {
        return await BaseRepository.getAsync(`${pilotId}`);
    },

    async updateCausationsAsync(id, incidentPilotJson) {
        return await BaseRepository.putAsync(`${id}/causations`, incidentPilotJson);
    },

    async getCausationsAsync(id) {
        return await BaseRepository.getAsync(`${id}/causations`);
    },

    async deleteAsync(incidentPilotId) {
        return await BaseRepository.deleteAsync(`${incidentPilotId}`);
    },

    async updateDetailsByIdAsync(incidentPilotId, incidentPilot) {
        return await BaseRepository.putAsync(`${incidentPilotId}/details`, incidentPilot);
    },

    async getDetailsAsync(incidentPilotId) {
        return await BaseRepository.getAsync(`${incidentPilotId}/details`);
    },

    async getCertificateLocationsAsync(incidentPilotId) {
        return await BaseRepository.getAsync(`${incidentPilotId}/certificate-locations`);
    },

    async getDetailsErrorsAsync(incidentPilotId) {
        return await BaseRepository.getAsync(`${incidentPilotId}/details/errors`);
    },
}

wrapMethodsWithLogging(IncidentPilotApiRepository);
